__turbopack_context__.v({
  "actions": "style-module-scss-module__LAzd-a__actions",
  "active": "style-module-scss-module__LAzd-a__active",
  "btnAlerts": "style-module-scss-module__LAzd-a__btnAlerts",
  "btnAlertsHighlight": "style-module-scss-module__LAzd-a__btnAlertsHighlight",
  "btnAsk": "style-module-scss-module__LAzd-a__btnAsk",
  "btnAskIcon": "style-module-scss-module__LAzd-a__btnAskIcon",
  "forceBackground": "style-module-scss-module__LAzd-a__forceBackground",
  "hamburger": "style-module-scss-module__LAzd-a__hamburger",
  "header": "style-module-scss-module__LAzd-a__header",
  "inner": "style-module-scss-module__LAzd-a__inner",
  "logo": "style-module-scss-module__LAzd-a__logo",
  "logoSvg": "style-module-scss-module__LAzd-a__logoSvg",
  "mobileAsk": "style-module-scss-module__LAzd-a__mobileAsk",
  "mobileMenu": "style-module-scss-module__LAzd-a__mobileMenu",
  "mobileMenuOpen": "style-module-scss-module__LAzd-a__mobileMenuOpen",
  "mobileNavLink": "style-module-scss-module__LAzd-a__mobileNavLink",
  "mobileNavLinks": "style-module-scss-module__LAzd-a__mobileNavLinks",
  "nav": "style-module-scss-module__LAzd-a__nav",
  "navLink": "style-module-scss-module__LAzd-a__navLink",
  "navLinks": "style-module-scss-module__LAzd-a__navLinks",
  "solidify": "style-module-scss-module__LAzd-a__solidify",
});
